import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";
import SmartFeedEngine from "@/smart-feed/smart-feed-engine";
import { useGeneralStore } from "%/stores/general-store";

export const useMyMonetizationLinksFeedStore = defineSmartFeedPiniaStore(
  "my-monetization-links-feed-store",
  {
    state: () => ({
      smartFeedEngine: new SmartFeedEngine(),
      tableFields: [
        {
          key: "affiliateLink",
          label: "Affiliate Link",
          width: "320px",
        },
        {
          key: "originalLink",
          label: "Original Link",
          width: "320px",
        },
        {
          key: "advertiserName",
          label: "Advertiser",
          width: "200px",
        },
        {
          key: "productDescription",
          label: "Product Description",
          width: "300px",
        },
        {
          key: "notes",
          label: "Notes",
          width: "300px",
        },
        {
          key: "brandName",
          label: "Brand Name",
          width: "200px",
        },
        {
          key: "productName",
          label: "Product Name",
          width: "200px",
        },
        {
          key: "clicks",
          label: "Clicks",
        },
        {
          key: "sales",
          label: "Sales",
        },
        {
          key: "totalEarnings",
          label: "Total Earnings",
        },
        {
          key: "pendingEarnings",
          label: "Pending Earnings",
        },
        {
          key: "lockedEarnings",
          label: "Locked Earnings",

        },
        {
          key: "actions",
          label: "",
        },
      ],
    }),
    getters: {
      feedUrl() {
        return `/affiliate-link/${useGeneralStore().orgId}/smartfeed`;
      },
    },
  },
);
